import {get, post, postJson, deleteApi, put} from './axios'

// 会员分群查询

const RESOURCE_BASE_PATH = '/shopBuyerGroup'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/shopBuyerGroup'

// 会员列表分页查询
export const getShopBuyerGroup = p => get(`${RESOURCE_BASE_PATH}/page`, p);

//删除会员
export const deleteBuyerGroupById = id => deleteApi(`${RESOURCE_BASE_PATH}/${id}`);

//创建会员分组
export const createBuyerGroup = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

//修改会员分组
export const reviseBuyerGroup = p => put(`${RESOURCE_BASE_PATH}/`, p);